import './Toastc.styles.scss'
export const ToastrContainer = () => <div id="oa-toastr-container" className='oa-toastr'></div>

export default ToastrContainer;